export const basePath = '/ins-and-outs/';
